/*
 * Which of the two orders a path belongs to, for presentation only.
 *
 * The crossroads needs it to decide which side of the alley a plate stands on;
 * the flow needs it to pick which of a step's two backdrops to show. Both are
 * cosmetic: if the test is wrong the two sides swap and the wrong-but-valid
 * frame appears, and nothing about the character or the request changes.
 *
 * It reads the path's own text rather than its id, because the ids are campaign
 * fixtures. The seeded names are `Path of JSon` (magic) and `Path of John`
 * (tech) — the pun is in the fixture, not here — and the descriptions say
 * "magical abilities" and "technical enhancements", so either field carries the
 * signal. The backend's own enum agrees: `TheChosenPath.MAGIC_JSON` /
 * `TECH_JOHN` (apps/core/models/core.py:362-365).
 *
 * This is deliberately NOT promoted to a contract with the backend. The honest
 * fix is a field on ThePath saying which order it is — recorded as gap G-28.
 */

const FLOW_MARKER = /magic|flow|arcane|json/i;

export function isFlowPath(path) {
    return FLOW_MARKER.test(`${path?.name ?? ''} ${path?.description ?? ''}`);
}

/* The asset-name suffix for a path: the two orders the artwork was cut for. */
export function flavourOf(path) {
    return isFlowPath(path) ? 'json' : 'john';
}
